import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { eagerlyLoadedModules } from './eager-load';

@NgModule({
  imports: [CommonModule, ...eagerlyLoadedModules],
})
export class DataStoreModule {}
